<template>
  <el-upload
    v-if="fileList.length===0"
    ref="upload"
    :accept="accept"
    :file-list="fileList"
    :show-file-list="false"
    :on-change="handlChange"
    :before-upload="handleBeforeUpload"
    :http-request="handleHttpRequest"
    :limit="1"
    :auto-upload="true">
    <el-button slot="trigger" size="mini" type="plain" icon="el-icon-upload">选择文件</el-button>
    </el-upload>
  <div v-else>
    <div class="flex">
        <img :src="typeIconSrc" width="14" class="right-space"/>
        <el-tooltip effect="dark" :content="fileList[0].name" placement="top" :open-delay="650">
        <span class="right-space">{{formatFileName(fileList[0].name)}}</span>
        </el-tooltip>
        <el-tooltip effect="dark" content="取消" placement="top" :open-delay="650">
        <img :src="removeIconSrc" width="8" class="right-space click" @click="handleRemove"/>
        </el-tooltip>
        <span class="right-space upload-info" v-if="isShowSizeAndSpeecInfo">{{ `[ 大小：${uploadItem.sizeFormat}，速度：${uploadItem.speed} Mb/s ]`}}</span>
        <el-tooltip effect="dark" content="重新上传" placement="top" :open-delay="650" v-if="uploadItem.status==='exception'">
        <img :src="reuploadIconSrc" width="9" class="click" @click="handleReupload"/>
        </el-tooltip>
    </div>
    <el-progress :percentage="uploadItem.percent" :status="uploadItem.status" style="width: 50%;"></el-progress>
  </div>
</template>

<script>
import * as util from '@/util/util';
import tencentCloud from '@/api/basic/tencent-cloud';
import tencentVodService from  '@/common/common-logic/tencentVod';
import { coursewareFileTypeEnums as COURSEWARE_FILE_TYPE_ENUM } from '@/const/crud/app/course';
import { getFileNameUUID, getOSSCourseware } from '@/api/basic/aliyunoss';
import uploadService from '@/common/common-logic/upload-service';
import { getDocument } from "pdfjs-dist";
import 'pdfjs-dist/build/pdf.worker.entry';

export default {
  props: {
    fileType: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      COURSEWARE_FILE_TYPE_ENUM,
      fileList: [],
      uploadItem: {
        rawFile: undefined,
        percent: 0,
        speed: 0,
        status: '',
        fileLength: undefined,
        fileUrl: undefined,
        uploader: undefined,
      },
      isShowSizeAndSpeecInfo: false,
      errorNotice: undefined,
    }
  },
  computed: {
    uploadTypeEnum() {
      for (const key in COURSEWARE_FILE_TYPE_ENUM) {
        const element = COURSEWARE_FILE_TYPE_ENUM[key];
          if (element.value === this.fileType) {
            return element;
          }
      }
      return null;
    },
    supportFormat() {
      return this.uploadTypeEnum.supportFormat;
    },
    accept() {
      return this.supportFormat.map(format => '.' + format).join(',');
    },
    typeIconSrc() {
      switch(this.fileType) {
        case COURSEWARE_FILE_TYPE_ENUM.IMAGE.value:
          return require('../../../../../static/images/course/icon-courseware-image.svg');

        case COURSEWARE_FILE_TYPE_ENUM.PDF.value:
          return require('../../../../../static/images/course/icon-courseware-pdf.svg');

        case COURSEWARE_FILE_TYPE_ENUM.VIDEO.value:
          return require('../../../../../static/images/course/icon-courseware-video.svg');
        default:
      }
    },
    reuploadIconSrc() {
      return require('../../../../../static/images/course/icon-courseware-reupload.svg');
    },
    removeIconSrc() {
      return require('../../../../../static/images/course/icon-courseware-remove.svg');
    },
  },
  methods: {
    checkFormat(filename) {
      const extension = filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
      if (this.supportFormat.includes(extension)) {
        return true;
      }
      return false;
    },
    createUploadItem(rawFile) {
      const sizeFormat = this.formatFileSize(rawFile.size)
      return {
        rawFile,
        sizeFormat,
        percent: 0,
        speed: 0,
        success: false, 
      }
    },
    handleBeforeUpload(file) {
      if (!this.checkFormat(file.name)) {
        this.$message({
          type: 'info',
          message: '文件格式不支持, 请重新选择文件',
        })
        return false;
      }
      if (file.size > 10 * Math.pow(1024, 3)) {
        this.$message({
          type: 'info',
          message: '上传的文件不能超过10GB',
        })
        return false;
      }
      this.fileList = [file]
    },
    handleHttpRequest(data) {
      const rawFile = data.file;
      const uploadItem = this.createUploadItem(rawFile);
      this.uploadItem = uploadItem;
      this.$emit('onStart');
      if (this.fileType === COURSEWARE_FILE_TYPE_ENUM.VIDEO.value) {
        this.TCVUpload(uploadItem);
      } else {
        this.OSSUpload(uploadItem);
      }
    },
    getVideoInfo(rawFile) {
      return new Promise((resolve) => {
        const videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(rawFile);
        videoElement.addEventListener("loadedmetadata", () => {
          resolve({ duration: videoElement.duration });
        });
      });
    },
    async TCVUpload(uploadItem) {
      // 云点播: 1. 获取签名 & 封面
      const coverImage = await util.generatorVideoCoverImage(uploadItem.rawFile);
      let params = { isDefaultVideoCover: !coverImage || !coverImage.src };
      const vodSignature = await this.requestWrapper(tencentCloud.getCourseVodSign, params);
      if (!vodSignature || vodSignature.ok === false) {
        this.$message({ message: '暂不支持此格式', type: 'error'});
        throw new Error('获取vod签名失败');
      }
      // 云点播: 2. 上传视频源
      try {
        // 2.1 获取视频播放时长
        const videoInfo = await this.getVideoInfo(uploadItem.rawFile);
        uploadItem.fileLength = videoInfo.duration.toFixed(0);
        // 2.2 上传视频源
        this.isShowSizeAndSpeecInfo = true;
        const onProgress = (percent, speed, uploader) => {
          uploadItem.percent = percent;
          uploadItem.speed = speed;
          uploadItem.uploader = uploader;
        };
        await tencentVodService.uploadVideoWithProcess(uploadItem.rawFile, vodSignature, onProgress).then((response) => {
            uploadItem.status = 'success';
            uploadItem.fileUrl = response.url;
            const dataSuccess = {
              fileId: response.fileId,
              fileUrl: uploadItem.fileUrl,
              fileLength: uploadItem.fileLength,
              coverImage,
            }
            this.$emit('onSuccess', dataSuccess);
        });
      } catch (error) {
        console.log(error);
        this.$emit('onError');
        uploadItem.status = 'exception';
        this.closeErrorNotice();
        this.errorNotice = this.$notify.error({
          title: '文件上传失败',
          message: '检查您的网络状态后重新上传',
          duration: 0,
        });
      } finally {
        this.isShowSizeAndSpeecInfo = false;
      }
    },
    async OSSUpload(uploadItem) {
      const { rawFile } = uploadItem;
      const { name } = uploadItem.rawFile;
      const fileKey = getOSSCourseware() + getFileNameUUID() + '_' + name;
      const onFileFinish = async (error, data, options) => {
        if (error) {
          console.log(error);
          this.$emit('onError');
          uploadItem.status = 'exception';
          this.closeErrorNotice();
          this.errorNotice = this.$notify.error({
            title: '文件上传失败',
            message: '检查您的网络状态后重新上传',
            duration: 0,
          });
        } else {
          uploadItem.fileUrl = `${data.host}/${options.Key}`;
          uploadItem.fileLength = 0;
          // 处理pdf总页数的读取
          if (this.fileType === COURSEWARE_FILE_TYPE_ENUM.PDF.value) {
            try {
              const pdf = await getDocument(uploadItem.fileUrl);
              uploadItem.fileLength = pdf.numPages || 1;
            } catch (error) {
              console.log(error);
            }
          }
          uploadItem.percent = 100;
          uploadItem.status = 'success';
          const dataSuccess = {
            fileUrl: uploadItem.fileUrl,
            fileLength: uploadItem.fileLength,
          }
          this.$emit('onSuccess', dataSuccess);
        }
      };

      const onProgress = (percent, speed) => {
        uploadItem.percent = percent;
        uploadItem.speed = speed;
        if (percent === 100 && uploadItem.status !== 'success') {
          uploadItem.percent = 99;
        }
      };

      try {
        this.isShowSizeAndSpeecInfo = true;
        await uploadService.uploadFiles([{
          key: fileKey,
          file: rawFile,
        }], onProgress, onFileFinish);
      } catch (error) {
        console.log(error);
        this.$emit('onError');
        uploadItem.status = 'exception';
        this.closeErrorNotice();
        this.errorNotice = this.$notify.error({
          title: '文件上传失败',
          message: '检查您的网络状态后重新上传',
          duration: 0,
        });
      } finally {
        this.isShowSizeAndSpeecInfo = false;
      }
    },
    formatFileName(value) {
      const dotIndex = value.lastIndexOf('.');
      if (dotIndex >= 15) {
        return `${value.substr(0, 8)}...${value.substr(value.lastIndexOf('.') -4)}`;
      } else {
        return value;
      }
    },
    formatFileSize(size) {
      if (!size)
        return 'unkown';
      const baseNumber = 1024.00;
      if (size < baseNumber) return size + 'B';
      if (size < Math.pow(baseNumber, 2)) return (size / baseNumber).toFixed(2) + 'KB';
      if (size < Math.pow(baseNumber, 3)) return (size / Math.pow(baseNumber, 2)).toFixed(2) + 'MB';
      return (size / Math.pow(baseNumber, 3)).toFixed(2) + 'GB';
    },
    resetUploadInfo() {
      this.fileList = [];
      this.uploadItem.rawFile = undefined;
      this.uploadItem.percent = 0;
      this.uploadItem.speed = 0;
      this.uploadItem.status = '';
    },
    closeErrorNotice() {
      if (this.errorNotice) {
        this.errorNotice.close();
      }
    },
    handleRemove() {
      this.$emit('onRemove');
      this.closeErrorNotice();
      this.resetUploadInfo();
      const { uploader } = this.uploadItem;
      if (uploader) uploader.cancel();
    },
    handleReupload() {
      this.$emit('onStart');
      this.closeErrorNotice();
      if (this.fileType === COURSEWARE_FILE_TYPE_ENUM.VIDEO.value) {
        this.TCVUpload(this.uploadItem);
      } else {
        this.OSSUpload(this.uploadItem);
      }
    },
  },
}
</script>
    
<style lang="scss">
.flex {
  display: flex;
}
.right-space {
  margin-right: 8px;
}
.click {
  cursor: pointer;
}
.upload-info {
  font-size: 12px;
}
</style>
